import React from "react";
import { useNavigate } from "react-router-dom";
import "./LegalPages.css";
import { useLang, LangToggle } from "../components/LangToggle";

export default function Privacy() {
  const navigate = useNavigate();
  const [lang] = useLang();

  return (
    <div className="legalPage">
      <button className="legalPage__back" onClick={() => navigate("/")}>
        {lang === "fr" ? "retour" : "back"}
      </button>
      <LangToggle />

      <div className="legalPage__content">
        {lang === "fr" ? (
          <>
            <h1 className="legalPage__title">politique de confidentialité</h1>
            <p className="legalPage__muted">Dernière mise à jour : 16/05/2026</p>

            <p>
              Cette politique explique comment Ghetto Symphony collecte et utilise
              les données personnelles. Le responsable de traitement est Hugo Armand
              Mbom, entrepreneur individuel exerçant sous le nom commercial Ghetto
              Symphony, SIRET 103 137 964 00013, 35 Passage Clemenceau, 34000
              Montpellier, France.
            </p>

            <h2>1. Données collectées</h2>
            <p>Selon vos actions, nous pouvons collecter :</p>
            <ul>
              <li>Coordonnées (nom, adresse email)</li>
              <li>Adresse de livraison et de facturation</li>
              <li>Détails de commande (articles, montants, statut de paiement)</li>
              <li>Messages clients (demandes de support)</li>
              <li>Adresse email en cas d'inscription à la newsletter</li>
            </ul>

            <h2>2. Utilisation des données</h2>
            <p>Nous utilisons les données pour :</p>
            <ul>
              <li>Traiter les commandes et organiser la livraison</li>
              <li>Fournir le support client</li>
              <li>
                Envoyer les emails liés aux commandes (confirmation, suivi
                d'expédition)
              </li>
              <li>
                Envoyer des emails marketing uniquement si vous y avez consenti
              </li>
              <li>Respecter les obligations légales et comptables</li>
            </ul>

            <h2>3. Prestataires</h2>
            <p>
              Nous faisons appel à des prestataires tiers de confiance pour exploiter
              la Boutique :
            </p>
            <ul>
              <li>
                <strong>Shopify Inc.</strong> — checkout, gestion des commandes,
                traitement des paiements
              </li>
              <li>
                <strong>Vercel Inc.</strong> — hébergement du site
              </li>
              <li>
                <strong>Mailchimp (Intuit Inc.)</strong> — newsletter et
                notifications email, si vous y avez consenti
              </li>
              <li>
                <strong>Transporteurs</strong> — expédition et logistique
              </li>
            </ul>
            <p>
              Ces prestataires ne traitent les données que dans la mesure nécessaire
              à ces services et sont soumis à leurs propres engagements de
              confidentialité.
            </p>

            <h2>4. Bases légales (UE/EEE)</h2>
            <p>Le cas échéant, nous traitons les données personnelles sur la base :</p>
            <ul>
              <li>
                <strong>de l'exécution du contrat</strong> — pour traiter et gérer
                vos commandes
              </li>
              <li>
                <strong>d'une obligation légale</strong> — comptabilité, prévention
                de la fraude, conformité réglementaire
              </li>
              <li>
                <strong>du consentement</strong> — emails marketing et newsletter
                (retirable à tout moment)
              </li>
            </ul>

            <h2>5. Conservation des données</h2>
            <p>
              Nous conservons les données uniquement le temps nécessaire aux
              finalités décrites, et aussi longtemps que la loi l'exige (notamment la
              loi comptable française qui impose la conservation des documents
              commerciaux pendant 10 ans).
            </p>

            <h2>6. Vos droits</h2>
            <p>
              En vertu du RGPD et du droit français applicable, vous disposez du
              droit de :
            </p>
            <ul>
              <li>Accéder à vos données personnelles</li>
              <li>Rectifier des données inexactes</li>
              <li>Demander l'effacement de vos données (« droit à l'oubli »)</li>
              <li>Vous opposer à ou limiter certains traitements</li>
              <li>
                Recevoir vos données dans un format structuré et portable
                (portabilité)
              </li>
              <li>
                Retirer votre consentement à tout moment (newsletter / marketing)
              </li>
              <li>Introduire une réclamation auprès de la CNIL (cnil.fr)</li>
            </ul>
            <p>Pour exercer vos droits, contactez : hugombom2005@gmail.com</p>

            <h2>7. Cookies</h2>
            <p>
              Ce site peut utiliser des cookies pour les fonctionnalités
              essentielles (session, panier). Aucun cookie de suivi n'est déposé sans
              votre consentement. Vous pouvez gérer ou supprimer les cookies via les
              réglages de votre navigateur à tout moment.
            </p>

            <h2>8. Transferts de données</h2>
            <p>
              Certains prestataires (Shopify, Vercel, Mailchimp) sont situés hors de
              l'UE. Les transferts sont encadrés par des garanties appropriées
              (clauses contractuelles types ou équivalent).
            </p>

            <h2>9. Contact</h2>
            <p>
              Pour toute question relative à la confidentialité :
              hugombom2005@gmail.com
            </p>
          </>
        ) : (
          <>
            <h1 className="legalPage__title">privacy policy</h1>
            <p className="legalPage__muted">Last update: 16/05/2026</p>

            <p>
              This policy explains how Ghetto Symphony collects and uses personal
              data. The data controller is Hugo Armand Mbom, entrepreneur individuel
              operating under the trade name Ghetto Symphony, SIRET 103 137 964
              00013, 35 Passage Clemenceau, 34000 Montpellier, France.
            </p>

            <h2>1. Data we collect</h2>
            <p>Depending on your actions, we may collect:</p>
            <ul>
              <li>Contact details (name, email address)</li>
              <li>Shipping and billing address</li>
              <li>Order details (items, amounts, payment status)</li>
              <li>Customer messages (support requests)</li>
              <li>Email address if you subscribed to our newsletter</li>
            </ul>

            <h2>2. How we use your data</h2>
            <p>We use data to:</p>
            <ul>
              <li>Process orders and coordinate delivery</li>
              <li>Provide customer support</li>
              <li>Send order-related emails (confirmation, shipping updates)</li>
              <li>Send marketing emails only if you have opted in</li>
              <li>Comply with legal and accounting obligations</li>
            </ul>

            <h2>3. Service providers</h2>
            <p>We use trusted third-party providers to operate the Store:</p>
            <ul>
              <li>
                <strong>Shopify Inc.</strong> — checkout, order management, payment
                processing
              </li>
              <li>
                <strong>Vercel Inc.</strong> — website hosting
              </li>
              <li>
                <strong>Mailchimp (Intuit Inc.)</strong> — newsletter and email
                notifications, if you opted in
              </li>
              <li>
                <strong>Delivery carriers</strong> — shipping and logistics
              </li>
            </ul>
            <p>
              These providers process personal data only as necessary to perform the
              services above and are bound by their own privacy commitments.
            </p>

            <h2>4. Legal basis (EU/EEA)</h2>
            <p>Where applicable, we process personal data based on:</p>
            <ul>
              <li>
                <strong>Contract performance</strong> — to fulfill and manage your
                orders
              </li>
              <li>
                <strong>Legal obligation</strong> — accounting, fraud prevention,
                regulatory compliance
              </li>
              <li>
                <strong>Consent</strong> — marketing emails and newsletter (you may
                withdraw at any time)
              </li>
            </ul>

            <h2>5. Data retention</h2>
            <p>
              We retain personal data only as long as necessary for the purposes
              described above, and for as long as required by applicable law (notably
              French accounting law which requires commercial records to be kept for
              10 years).
            </p>

            <h2>6. Your rights</h2>
            <p>Under the GDPR and applicable French law, you have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data ("right to be forgotten")</li>
              <li>Object to or restrict certain processing</li>
              <li>Receive your data in a structured, portable format (data portability)</li>
              <li>Withdraw consent at any time (for newsletter / marketing)</li>
              <li>Lodge a complaint with the CNIL (cnil.fr)</li>
            </ul>
            <p>To exercise your rights, contact: hugombom2005@gmail.com</p>

            <h2>7. Cookies</h2>
            <p>
              This website may use cookies for essential site functionality (session,
              cart). No tracking cookies are set without your consent. You can manage
              or delete cookies through your browser settings at any time.
            </p>

            <h2>8. Data transfers</h2>
            <p>
              Some providers (Shopify, Vercel, Mailchimp) are based outside the EU.
              Transfers are covered by appropriate safeguards (Standard Contractual
              Clauses or equivalent).
            </p>

            <h2>9. Contact</h2>
            <p>For any privacy-related question: hugombom2005@gmail.com</p>
          </>
        )}
      </div>
    </div>
  );
}
